import { zodResolver } from '@hookform/resolvers/zod'
import { Button, Center, Paper, Stack, Title } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { authClient } from '~/api/auth-client'
import { PasswordInput, TextInput } from '~/components/primitives/form'

export const Route = createFileRoute('/sign-in')({
  component: SignIn,
})

const signInSchema = z.object({
  email: z.email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
})

type SignInFormData = z.infer<typeof signInSchema>

function SignIn() {
  const navigate = useNavigate()
  const session = authClient.useSession()

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<SignInFormData>({
    resolver: zodResolver(signInSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = async (data: SignInFormData) => {
    const { error } = await authClient.signIn.email({
      email: data.email,
      password: data.password,
    })
    if (error) {
      notifications.show({
        title: 'Sign in failed',
        message: error.message || 'Invalid credentials',
        color: 'red',
      })
    }
  }

  useEffect(() => {
    if (session.data) {
      navigate({ to: '/' })
    }
  }, [session.data, navigate])

  return (
    <Center mih="100vh">
      <Paper shadow="md" p="xl" withBorder w={400}>
        <Stack gap="md">
          <Title order={2} ta="center">
            Hypersonic
          </Title>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack gap="md">
              <TextInput
                name="email"
                control={control}
                label="Email"
                placeholder="your@email.com"
                required
              />

              <PasswordInput
                name="password"
                control={control}
                label="Password"
                placeholder="Your password"
                required
              />

              <Button type="submit" fullWidth mt="md" loading={isSubmitting}>
                Sign In
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Center>
  )
}
